
(function(){
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var rvs = document.querySelectorAll('.rv');
  if (reduce || !('IntersectionObserver' in window)) {
    rvs.forEach(function(el){ el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold:.12, rootMargin:'0px 0px -40px' });
    rvs.forEach(function(el){ io.observe(el); });
  }

  // Carrousel hero
  var slides = document.querySelectorAll('.slide');
  var copies = document.querySelectorAll('.copy');
  var dots   = document.querySelectorAll('.dot');
  var heroEl = document.getElementById('hero');
  if (slides.length > 1 && heroEl) {
    var cur = 0, auto = null;
    function show(i){
      cur = (i + slides.length) % slides.length;
      slides.forEach(function(el,k){
        el.classList.toggle('on', k===cur);
        var v = el.querySelector('video');
        if (v) {
          if (k===cur && !reduce) { v.play().catch(function(){}); }
          else { v.pause(); }
        }
      });
      copies.forEach(function(el,k){ el.classList.toggle('on', k===cur); });
      dots.forEach(function(el,k){ el.classList.toggle('on', k===cur); });
    }
    function play(){ if(!reduce){ stop(); auto = setInterval(function(){ show(cur+1); }, 5500); } }
    function stop(){ clearInterval(auto); auto = null; }
    dots.forEach(function(d,k){ d.addEventListener('click', function(){ show(k); play(); }); });
    heroEl.addEventListener('mouseenter', stop);
    heroEl.addEventListener('mouseleave', play);
    document.addEventListener('visibilitychange', function(){ document.hidden ? stop() : play(); });
    show(0);
    play();
  }

  // Test de réaction
  var pods = Array.prototype.slice.call(document.querySelectorAll('.pod'));
  var goBtn = document.getElementById('go');
  if (pods.length && goBtn) {
    var COLORS = ['#FF3B30','#17C062','#2F80FF','#F5A800'];
    var stateEl = document.getElementById('state'), hintEl = document.getElementById('hint');
    var rLast = document.getElementById('rLast'), rBest = document.getElementById('rBest'), rAvg = document.getElementById('rAvg');
    var TOTAL = 10, running=false, active=-1, litAt=0, count=0, times=[], timer=null, cd=null;
    function fmt(el,v){ el.innerHTML = (v===null?'—':v) + '<small>ms</small>'; }
    function clearPods(){ pods.forEach(function(p){ p.classList.remove('on'); p.style.color=''; }); }
    function reset(){
      running=false; active=-1; count=0; times=[];
      clearTimeout(timer); clearInterval(cd); clearPods();
      fmt(rLast,null); fmt(rBest,null); fmt(rAvg,null);
      stateEl.textContent='Prêt'; goBtn.textContent='Lancer';
    }
    function light(){
      clearPods();
      var i = Math.floor(Math.random()*pods.length);
      if (i===active) i = (i+1+Math.floor(Math.random()*(pods.length-1))) % pods.length;
      active=i;
      pods[i].style.color = COLORS[Math.floor(Math.random()*COLORS.length)];
      pods[i].classList.add('on');
      litAt = performance.now();
    }
    function next(){ if(!running) return; timer=setTimeout(light, 350 + Math.random()*750); }
    function finish(){
      running=false; clearPods(); active=-1;
      stateEl.textContent='Terminé'; goBtn.textContent='Recommencer';
      hintEl.textContent = Math.min.apply(null,times)<380
        ? 'Sérieux niveau. Un joueur pro tourne autour de 350 ms.'
        : 'Bonne base. C’est exactement ce que les séances font baisser.';
    }
    function start(){
      reset(); running=true; goBtn.textContent='Arrêter';
      var n=3; stateEl.textContent=n; hintEl.textContent='Prépare-toi.';
      cd=setInterval(function(){
        n--;
        if(n>0){ stateEl.textContent=n; return; }
        clearInterval(cd);
        if(!running) return;
        stateEl.textContent='0 / '+TOTAL;
        hintEl.textContent='Touche le plot allumé le plus vite possible.';
        next();
      },700);
    }
    goBtn.addEventListener('click', function(){
      if(running){ reset(); hintEl.textContent='Touche le plot allumé le plus vite possible.'; }
      else start();
    });
    pods.forEach(function(p,idx){
      p.addEventListener('click', function(){
        if(!running || active!==idx) return;
        var ms = Math.round(performance.now()-litAt);
        times.push(ms); count++;
        p.classList.add('hit'); setTimeout(function(){ p.classList.remove('hit'); },90);
        clearPods(); active=-1;
        fmt(rLast,ms); fmt(rBest,Math.min.apply(null,times));
        fmt(rAvg,Math.round(times.reduce(function(a,b){return a+b;},0)/times.length));
        stateEl.textContent = count+' / '+TOTAL;
        if(count>=TOTAL) finish(); else next();
      });
    });
  }

  // Sélecteur de quantité
  document.querySelectorAll('.qty').forEach(function(box){
    var input = box.querySelector('input');
    box.querySelectorAll('button').forEach(function(btn){
      btn.addEventListener('click', function(){
        var v = parseInt(input.value, 10) || 1;
        v += parseInt(btn.dataset.q, 10);
        input.value = Math.min(99, Math.max(1, v));
      });
    });
  });

  // Vidéos de la grille : lecture quand elles sont visibles
  var reelVids = document.querySelectorAll('.rc-media video');
  reelVids.forEach(function(v){
    var card = v.parentNode;
    var tap = card.querySelector('.play.tap');
    function sync(){ if (tap) tap.classList.toggle('hide', !v.paused); }
    v.addEventListener('playing', sync);
    v.addEventListener('pause', sync);
    if (tap) tap.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      if (v.paused) { v.play().catch(function(){}); } else { v.pause(); }
    });
    v.muted = true;
    v.setAttribute('muted','');
    if (!reduce) { v.play().catch(function(){}); }
    // secours : un appui lance ou met en pause
    v.addEventListener('click', function(){
      if (v.paused) { v.play().catch(function(){}); } else { v.pause(); }
    });
  });
  if (reelVids.length && 'IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function(es){
      es.forEach(function(e){
        var v = e.target;
        if (e.isIntersecting && !reduce) { v.play().catch(function(){}); }
        else { v.pause(); }
      });
    }, { threshold:.15 });
    reelVids.forEach(function(v){ vio.observe(v); });
  }
  // certains navigateurs n'autorisent la lecture qu'après une première interaction
  ['touchstart','click','scroll'].forEach(function(ev){
    window.addEventListener(ev, function once(){
      reelVids.forEach(function(v){ if (v.paused && !reduce) v.play().catch(function(){}); });
      window.removeEventListener(ev, once);
    }, { passive:true });
  });

  // Flèches du carrousel de vidéos
  document.querySelectorAll('.reelcar-nav').forEach(function(nav){
    var car = nav.closest('.wrap').querySelector('.reelcar');
    if (!car) return;
    nav.querySelectorAll('button').forEach(function(btn){
      btn.addEventListener('click', function(){
        var step = (car.querySelector('.rc-item') || {}).offsetWidth || 220;
        car.scrollBy({ left: (step + 14) * 2 * parseInt(btn.dataset.dir, 10), behavior:'smooth' });
      });
    });
  });

  // Formulaire de devis (démo : aucun envoi réel)
  var form = document.getElementById('devis-form');
  if (form) {
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var picked = Array.prototype.slice.call(form.querySelectorAll('.pick input[type=checkbox]:checked'))
        .map(function(c){
          var q = c.closest('.pick').querySelector('input[type=number]');
          return c.dataset.label + (q && q.value ? ' × ' + q.value : '');
        });
      var box = document.getElementById('devis-sent');
      var list = document.getElementById('devis-list');
      if (!picked.length) { picked = ['Aucun produit sélectionné']; }
      list.innerHTML = picked.map(function(p){ return '<li>'+p+'</li>'; }).join('');
      box.classList.add('on');
      box.scrollIntoView({behavior:'smooth', block:'center'});
    });
  }
})();
